export interface ChangeEntry {
  field: string;
  oldValue: string | null;
  newValue: string | null;
}

export interface ActivityLogRow {
  id: string;
  comment: string;
  entityName: string;
  entityId: string;
  activityLogType: number;
  activityLogTypeName: string;
  userFullName: string;
  userId: string;
  created: string;
  changes: ChangeEntry[] | null;
  entityDescription: string | null;
}

export enum ActivityLogTypeEnum {
  Create = 1,
  Update = 2,
  Delete = 3,
  Import = 4,
  Publish = 5,
}
